import '/Users/josiahayres/GitHub/storybook-addon-mantine/node_modules/@storybook/addon-essentials/dist/controls/manager.mjs';